import { useQuery } from "@tanstack/react-query";
import type { ApiColeta } from "pages/coleta/types/ApiColeta";
import type { ApiColetaItem } from "pages/coleta/types/ApiColetaItem";
import { apiRelLitragemColeta } from "pages/relatorios/api/apiRelLitragemColeta";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, columnsItens, TableRelLitragemColeta } from "./TableRelLitragemColeta";

export function RelatorioLitragemColeta() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelLitragemColeta", params],
		queryFn: () => apiRelLitragemColeta({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<ApiColeta, ApiColetaItem> = useMemo(() => {
		return {
			type: "expandable",
			fileName: "relatorio-litragem-coleta",
			options: {
				parentColumns: columns,
				childColumns: columnsItens,
				data: registros,
				childKey: "itens",
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados de Litragem de Coleta";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Litragem", "Coleta"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelLitragemColeta data={data?.registros} title={title} />}
		/>
	);
}
